<div class="section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-sm-12">

        <br/><br/>

        <div class="optout-card">
          <h1>Opt Out from Our Emails</h1>
          <p class="intro">
            You can use this form to opt out from receiving email notifications.
            Update your preferences below and save when finished.
          </p>

          <form [formGroup]="form">
            <div class="form-group mb-3">
              <label for="emailAddress">E-mail address</label>
              <input
                id="emailAddress"
                type="email"
                formControlName="emailAddress"
                class="form-control"
                readonly
              />
            </div>

            <div class="form-group mb-2">
              <label class="checkbox-row">
                <input
                  type="checkbox"
                  formControlName="unsubscribeLogistics"
                  (change)="onLogisticsChange($event)"
                />
                &nbsp;&nbsp;<span style="margin-left: 8px;">Unsubscribe from Logistic Notification</span>
              </label>
            </div>

            <div class="form-group mb-3">
              <label class="checkbox-row">
                <input
                  type="checkbox"
                  formControlName="unsubscribeMarketing"
                  (change)="onMarketingChange($event)"
                />
                 &nbsp;&nbsp;<span style="margin-left: 8px;">Unsubscribe from Marketing and General Materials</span>
              </label>
            </div>

            <hr/>

            <div class="action-buttons">
              <button
                type="button"
                class="btn btn-axp-theme me-2"
                [disabled]="isSubmitting"
                (click)="savePreferences()"
              >
                Save Preferences
              </button>
              <button type="button" class="btn btn-secondary" (click)="cancel()">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>